import React from 'react';
import './Styles/Categories.scss';
import {ReactComponent as Video} from '../../../Assets/Icons/video.svg';
import { helpData } from './data';
import { FiArrowRight } from 'react-icons/fi';
const Categories=()=>{
    return(
        <div className="categories-help">
         <Video />
         <h1>All categories</h1>
       <div className="cards">
       {helpData.map((d) =>{
             return(
                 <Card {...d} />
             )
         })}
       </div>
        </div>
    )
};
export default Categories;

export function Card(props){
    return(
        <div className="help-card">
            <div className="title">
                <div>
                    <div className="circle" style={{ background: `${props.cBg}` }}>
                       <img src= {props.icon} />
                    </div>
                </div>
                <h2>{props.title}</h2>
            </div>
            <p>{props.desc1}</p>
            <p>{props.desc2}</p>
            <p>See all articles </p>
            <div className="triangle" style={{ background: `${props.cBg}` }}></div>
           
        </div>
    )
};